/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { injectable } from 'inversify'
import { ITopNavBarApiClient } from './contracts'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { IUserSessionMiddleware } from '../../arc/middleware/UserSessionMiddleware/contracts'

@injectable()
export class TopNavBarApiClient implements ITopNavBarApiClient {
	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	getAuthorizationStatus(requiredPermission: number): Promise<boolean | void> {
		return this.userSessionMiddleware
			.ifPermissionExists(requiredPermission)
			.then(response => {
				return Promise.resolve(response)
			})
			.catch(error => {
				console.log(error)
				return Promise.resolve(false)
			})
	}
}
